// extracted by mini-css-extract-plugin
module.exports = {"skill-attitude":"J1GWI"};